import Component from '../Component';
import { detectHash } from '../Helpers';
import $ from '../../vendor/CustomJquery';

export default class Tabs extends Component {

  configure() {
    this.cookieTTL = 720; // In days
    return super.configure();
  }

  initialize() {

    this.tabs = $('.tabs li a[href*="#"]');
    this.tabsContent = $('.tab-content');

    this.onLoad();
    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {
    this.tabs.on('click', (event) => {
      return this.onClick(event);
    });
  }

  onClick(event) {
    let target = detectHash($(event.currentTarget).attr('href'));
    this.showTargetTab(target);
    // event.preventDefault();
  }

  onLoad() {
    if (this.tabs.length === 0) return;
    this.showActiveTab();
    this.detectTabsWithErrors();
  }

  showActiveTab() {
    let target = detectHash(window.location.toString());
    if (this.tabs.length > 0 && target !== null) {
      this.showTargetTab(target);
    }
    /*
    if (this.tabs.length > 0 && this.tabs.closest('li').filter('.is-active').length === 0) {
      this.showTargetTab(target);
    }*/
  }

  showTargetTab(target) {
    $('.tabs li a[href*="#'+ target +'"]').closest('li').addClass('is-active').siblings().removeClass('is-active');
    this.tabsContent.filter('[data-tab="'+ target +'"]').addClass('is-active').siblings().removeClass('is-active');

    // Change action url of parent form
    let form = this.tabsContent.closest('form'),
        action = form.attr('action');

    if (form.length === 1) {
      let url = action.split('#')[0];
      form.attr('action', url +'#'+ target);
    }
  }

  detectTabsWithErrors() {

    let isAnyTabWithErrorActive = false;

    this.tabs.each((i, tab) => {

      tab = $(tab);

      let target = detectHash(tab.attr('href')),
          label  = tab.find('span'),
          content = this.tabsContent.filter('[data-tab="'+ target +'"]'),
          errors = 0;

      if (content.length === 1 && label.length === 1) {

        errors = content.find('.help.is-danger').length;

        if (errors > 0) {
          label.attr('data-badge', errors).addClass('badge is-badge-danger');
          if (isAnyTabWithErrorActive === false) {
            isAnyTabWithErrorActive = true;
            this.showTargetTab(target);
          }
        }

      }

    });
  }

}